<template>
  <div>
    <List
      url="getAccountList"
      deleteUrl="deleteAccount"
      :tanle="tanle"
      :update="updateList"
      :afterList="dealGrade"
      :data="searchData"
      :isAdd="true"
      @add="add"
      @edit="edit"
      :operat="operat">
      <div slot="Filter">
        <el-input v-model="searchData.Key" placeholder="Email" style="width:400px;"></el-input>
        <el-button @click="updateList++" type="primary" style="margin-left:10px;">Search</el-button>
      </div>
    </List>
    <UpdateBox
      :updateType="updateType"
      :type="type"
      :initForm="updateForm"
      v-if="updateBlock"
      @close="updateBlock = false"
      @update="updateList++"
    ></UpdateBox>
  </div>
</template>

<script>
import List from "../components/common/List.vue";
import { ACCOUNTGRADE } from "@/components/Account/data.js";
import UpdateBox from "../components/Account/UpdateBox.vue";
export default {
    components: {
        List,
        UpdateBox
    },
    data() {
        return {
            tanle: [
                { name: "FullName", label: "Full Name" },
                { name: "Email", label: "Email" },
                { name: "TypeName", label: "Type" }
            ],
            searchData: { Key: "" },
            updateList: 0,
            type:1,
            updateType: "add",
            updateForm: {},
            updateBlock: false,
            operat: [{
                text: "Delete",
                eventName: "delete",
                type: "danger",
                PretreatMethod: "confirmDelete"
            },{
                text:"Edit",
                eventName:"edit",
                type:'primary',
                method (data) {
                    return (data.Status !== "1");
                } 
            }]
        };
    },
    mounted() {
        
    },
    methods: {
        dealGrade (data) {
            for(let i in data) {
                data[i].TypeName = ACCOUNTGRADE[data[i].Type];
                data[i].FullName = data[i].FirstName + " " + data[i].LastName;
            }
            return data;
        },
        add () {
            this.updateForm = {
                FirstName:"",
                LastName:"",
                Email:"",
                Password:"",
                ConfirmPassword:"",
                Type:"0"
            };
            this.type = localStorage.getItem("type");
            this.updateType = "add";
            this.updateBlock = true;
        },
        edit (val) {
            this.updateForm = val;
            this.type = localStorage.getItem("type");
            this.updateType = "edit";
            this.updateBlock = true;
        }
    },
    computed: {},
    watch:{}
};
</script>
